module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago_2x-3d9b8fa54db6f864d26fb4cab9119126.png";